import {
  fetchClient
} from "./chunk-64N4INLD.mjs";
import {
  resolveCaptcha
} from "./chunk-UELQYFJ7.mjs";
import {
  ApiConfig
} from "./chunk-IITKCRXL.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-RGHW4PYM.mjs";

// src/core/wbk/auth/otp.ts
import { generateMd5, getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var verifyOtp = (_0) => __async(null, [_0], function* ({ email, otp, verify_otp, guest_id, locale }) {
  var _a, _b, _c, _d, _e, _f;
  try {
    const lang = getLocaleOnly(locale);
    const signature = generateMd5(email);
    const captcha = yield resolveCaptcha("login");
    const data = yield fetchClient({
      url: "/verify-otp",
      baseUrl: (_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.authApi,
      options: {
        method: "POST",
        body: JSON.stringify(__spreadProps(__spreadValues({
          email,
          code: otp
        }, captcha), {
          signature,
          lang,
          verify_otp,
          guest_id
        }))
      }
    });
    if (((_c = data.status) == null ? void 0 : _c.toLowerCase()) === "success") {
      if (verify_otp || !((_d = data == null ? void 0 : data.data) == null ? void 0 : _d.user)) {
        return data.data;
      }
      return __spreadProps(__spreadValues({}, data.data), {
        user: __spreadProps(__spreadValues({}, data.data.user), {
          cell_number: data.data.user.phone || data.data.user.cell_number
        })
      });
    }
    const error = ((_e = data == null ? void 0 : data.error) == null ? void 0 : _e.description) || (data == null ? void 0 : data.error) || {};
    const errorsObj = typeof error === "string" ? { error } : error;
    const possibleFirstError = (_f = Object.values(errorsObj)) == null ? void 0 : _f[0];
    const msg = Array.isArray(possibleFirstError) ? possibleFirstError[0] : possibleFirstError;
    throw new Error(msg);
  } catch (error) {
    throw new Exception({
      error,
      name: "verifyOtpException",
      context: { tags: { journey: "auth" } }
    });
  }
});
var sendOtp = (data) => __async(null, null, function* () {
  try {
    const captcha = yield resolveCaptcha("send_otp");
    yield fetchClient({
      url: "/send-otp",
      options: {
        method: "POST",
        body: JSON.stringify(__spreadValues(__spreadValues({}, data), captcha))
      }
    });
  } catch (error) {
    throw new Exception({
      error,
      name: "sendOtpException"
    });
  }
});
var resendOtp = (_0) => __async(null, [_0], function* ({ email, locale }) {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  try {
    const captcha = yield resolveCaptcha("resend_otp");
    const signature = generateMd5(email);
    const lang = getLocaleOnly(locale);
    const data = yield fetchClient({
      url: "/signup",
      baseUrl: (_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.authApi,
      options: {
        method: "POST",
        body: JSON.stringify(__spreadProps(__spreadValues({
          email,
          resend: true
        }, captcha), {
          signature,
          app_source: (_d = (_c = ApiConfig.config) == null ? void 0 : _c.wbk) == null ? void 0 : _d.appSource,
          lang,
          skip_email_verification: true
        }))
      }
    });
    let res = data;
    if (data == null ? void 0 : data.original) {
      res = data.original;
    }
    if (((_e = res == null ? void 0 : res.status) == null ? void 0 : _e.toLowerCase()) === "success") {
      return data.data;
    }
    const err = ((_f = res == null ? void 0 : res.error) == null ? void 0 : _f.description) || ((_h = (_g = res == null ? void 0 : res.original) == null ? void 0 : _g.error) == null ? void 0 : _h.description) || Object.values((res == null ? void 0 : res.error) || {})[0];
    throw new Error(err);
  } catch (error) {
    throw new Exception({
      error,
      name: "resendOtpException",
      context: { tags: { journey: "auth" } }
    });
  }
});

export {
  verifyOtp,
  sendOtp,
  resendOtp
};
//# sourceMappingURL=chunk-KXEKEMBD.mjs.map